import { useState } from 'react';
import FrontTutorialUploadFile from './FrontTutorialUploadFile';
import FrontCamera from './FrontCamera';
import BackTutorial from './BackTutorial';
import BackCamera from './BackCamera';

type TPageMode =
  | 'front-tutorial-upload-file'
  | 'front-camera'
  | 'back-tutorial'
  | 'back-camera';

function IdentityFront() {
  const [mode, setMode] = useState<TPageMode>('front-tutorial-upload-file');

  return (
    <>
      {mode === 'front-tutorial-upload-file' && (
        <FrontTutorialUploadFile
          onClickOpenCamera={() => setMode('front-camera')}
        />
      )}
      {mode === 'front-camera' && (
        <FrontCamera
          onClickCloseCamera={() => setMode('front-tutorial-upload-file')}
          onSuccessSend={() => setMode('back-tutorial')}
        />
      )}
      {mode === 'back-tutorial' && (
        <BackTutorial onClickOpenCamera={() => setMode('back-camera')} />
      )}
      {mode === 'back-camera' && (
        <BackCamera onClickCloseCamera={() => setMode('back-tutorial')} />
      )}
    </>
  );
}

export default IdentityFront;
